import { render, staticRenderFns } from "./newRightLogin.vue?vue&type=template&id=3dde455e&scoped=true"
import script from "./newRightLogin.vue?vue&type=script&lang=js"
export * from "./newRightLogin.vue?vue&type=script&lang=js"
import style0 from "./newRightLogin.vue?vue&type=style&index=0&id=3dde455e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dde455e",
  null
  
)

export default component.exports